import React, { Component } from "react";
import { message, Button, Row, Card, Col, Spin } from "antd";
import soap_materiais from "../store/soap/zws_app_buscar_materiais.js";

export default class Reasearch extends Component {
  state = {
    materiais: [],
    materiaisAll: [],
    load: true,
    material: {},
    category: [],
  };

  componentDidMount() {
    try {
      if (localStorage.getItem("pesquisa") !== null) {
        soap_materiais
          .getMateriais()
          .then(this.loadMateriais)
          .catch((e) => {
            throw e;
          });
      } else {
        throw new Error("NotFound");
      }
    } catch (e) {
      this.setState({
        materiais: [],
        load: false,
      });
      message.warning("Erro ao tentar carregar lista. Tente novamente.");
    }
  }

  loadMateriais = (_materiais) => {
    const _category = [];
    _materiais.map((material) => {
      try {
        const isCategory = _category.find(
          (category) => category.name === material.LTEXT._text
        );
        if (!isCategory) {
          _category.push({
            name: material.LTEXT._text,
            total: 1,
            totalConcluded: material.PRECO_NOVO_VJ._text === "0.0" ? 0 : 1,
            concorrente: material.CONCORRENTE._text,
          });
        } else {
          isCategory.total += 1;
          if (material.PRECO_NOVO_VJ._text !== "0.0") {
            isCategory.totalConcluded += 1;
          }
        }
  
        return material;
      } catch(error) {
        console.log(error);
      }
    });
    this.setState({
      category: _category,
      load: false,
    });
  };

  research(item) {
    this.props.history.push(
      "/research/" + item.concorrente + "?category=" + item.name
    );
  }

  render() {
    return (
      <>
        {this.state.load && <Spin className="spin-dma" />}

        {this.state.category.length === 0 && !this.state.load && (
          <h1 style={{ margin: 10, textAlign: "center" }}>Não há produtos cadastrados</h1>
        )}

        {this.state.category.length > 0 && !this.state.load && (
          <Row gutter={24}>
            <h2 style={{ margin: 10, textAlign: "center" }}>Categorias</h2>
            {this.state.category.map((item, key) => {
              return (
                <Col key={key} span={24}>
                  <Card
                    style={{ margin: 10 }}
                    type="inner"
                    title={item.name}
                    extra={
                      <Button
                        type="text"
                        size="small"
                        onClick={() => this.research(item)}
                      >
                        Produtos
                      </Button>
                    }
                  >
                    <div>Total de itens: {item.total}</div>
                    <div>Total de itens concluídos: {item.totalConcluded}</div>
                  </Card>
                </Col>
              );
            })}
          </Row>
        )}
      </>
    );
  }
}
